import { normalizeLocale } from './normalize'

export function resolveLocale({ priority }, context) {
  for (const entry of priority) {
    if (entry.when && !entry.when(context)) {
      continue
    }

    if (entry.priority) {
      const result = resolveLocale(entry, context)
      if (result.locale) {
        return result
      }
      continue
    }

    const candidate = entry.read(context)
    const locale = entry.validate === false ? candidate : normalizeLocale(candidate, context.availableLocales)
    if (locale) {
      return { locale, source: entry.name }
    }
  }

  return { locale: null, source: null }
}
